import {ModalWrapper} from "reoverlay";
import React from "react";
import Spinner from "../../Spinner";
const LoadingModal=({text=""})=>{

    return <ModalWrapper onClose={()=>{}} animation="slideUp" contentContainerClassName="w-11/12 md:w-5/12 fixed w-full bottom-0 bg-gray-50 lg:w-4/12 p-5 rounded-t-lg" >
        <div className="edit-bill-modal-wrapper flex flex-col items-center justify-center">
            <Spinner className="text-3xl text-primary"/>
            <p className="text-sm mt-2 ">{text}</p>
        </div>
          </ModalWrapper>
}
export default LoadingModal;